import React from 'react';
import {WebUI} from "../../wui-core/src/index"
import Radio from './Radio';
import { RadioProps } from './iRadio';

/**
 * RadioButton 函数式组件
 * 本质上是Radio组件的一个样式变体
 */
const RadioButton: React.FC<RadioProps> = (props) => {
    return <Radio {...props} />;
};

export default WebUI({name: "radio-button"})(RadioButton);
